enum TransactionType {
  HOURLY=1,
  ON_CALL=2,
  OVERTIME=3,
  DAILY=4,
  HOURLY_HOLIDAY=5,
  ON_CALL_HOLIDAY=6,
  OVERTIME_HOLIDAY=7,
  DAILY_HOLIDAY=8,
  PER_DIEM=9,
  ADMIN_FEE=10,
  MILEAGE=11,
  GAS_RECIEPT=12,
  AIRFARE=13,
  BAGGAGE_RECEIPT=14,
  RENTAL_CAR=15,
  LODGING=16,
  CORRECTION=17,
  OTHER=18,
  ELECTRONIC_PAYMENT_FEE=19,
  FINDERS_FEE=20,
  LONG_TERM_CARE=21
}

export const providerlessTransactionTypes = [TransactionType.ADMIN_FEE, TransactionType.ELECTRONIC_PAYMENT_FEE];

export default TransactionType;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/enums/transactionTypeEnum.ts